import { apiGet } from '@api/api.utils'

import { 
    IResponseAccessLevels,
    IResponseAccessSections,
    IResponseAccessSites,
    IResponseApplicationSource, 
    IResponseApplicationStatuses, 
    IResponseApplicationType, 
    IResponseApplicationsNumber, 
    IResponseAttestationType, 
    IResponseCitizenships, 
    IResponseCommercialOffersDocuments, 
    IResponseCommercialOffersStatus, 
    IResponseContractDocuments, 
    IResponseContractSections, 
    IResponseContractSended, 
    IResponseContractSignatureStatuses, 
    IResponseContractTypes, 
    IResponseContractViews, 
    IResponseContractsStatuses, 
    IResponseCoursePrograms, 
    IResponseCourses, 
    IResponseCoursesContract, 
    IResponseDocumentTypes, 
    IResponseEducationLevels, 
    IResponsePrintStatus, 
    IResponseProgramType, 
    IResponseSitesDbName, 
    IResponseVolumeHours 
} from "./api.types"


/** Маршрут на сервер */
const route = '/dict'


/** Получение - Имена баз данных сайтов */
export const getSiteDbName = (): Promise<IResponseSitesDbName> => 
    apiGet<IResponseSitesDbName>(`${route}/getSiteDbName`)

/** Получение - Наименование курсов */
export const getCourses = (source: string): Promise<IResponseCourses> => 
    apiGet<IResponseCourses>(`${route}/getCourses`, {params: {source}})

/** Получение - Курсы для договора */
export const getCoursesContract = (source: string): Promise<IResponseCoursesContract> => 
    apiGet<IResponseCoursesContract>(`${route}/getCoursesContract`, {params: {source}})

/** Получение - Информация по программе для договора */
export const getContractProgramInfo = (source: string, courseID: number): Promise<IResponseCoursesContract> => 
    apiGet<IResponseCoursesContract>(`${route}/getContractProgramInfo`, {params: {source, courseID}})

/** Получение - Типы программ */
export const getProgramType = (source: string, courseID: number): Promise<IResponseProgramType> => 
    apiGet<IResponseProgramType>(`${route}/getProgramType`, {params: {source, courseID}})

/** Получение - Тип аттестации */
export const getAttestationType = (): Promise<IResponseAttestationType> => 
    apiGet<IResponseAttestationType>(`${route}/getAttestationType`)

/** Получение - Обьем программы в часах */
export const getVolumeHours = (source: string, courseID: number, programID: number): Promise<IResponseVolumeHours> => 
    apiGet<IResponseVolumeHours>(`${route}/getVolumeHours`, {params: {source, courseID, programID}})

/** Получение - Программы по курсу */
export const getCoursePrograms = (source: string, courseID: number): Promise<IResponseCoursePrograms> => 
    apiGet<IResponseCoursePrograms>(`${route}/getCoursePrograms`, {params: {source, courseID}})

/** Получение - Статусы заявок */
export const getApplicationStatuses = (): Promise<IResponseApplicationStatuses> => 
    apiGet<IResponseApplicationStatuses>(`${route}/getApplicationStatuses`)

/** Получение - Тип заявки */
export const getApplicationType = (): Promise<IResponseApplicationType> => 
    apiGet<IResponseApplicationType>(`${route}/getApplicationType`)

/** Получение - Источник заявки */
export const getApplicationSource = (): Promise<IResponseApplicationSource> => 
    apiGet<IResponseApplicationSource>(`${route}/getApplicationSource`)

/** Получение - Номера заявок */
export const getApplicationsNumber = (applicationStatusesID: string, search: string = ''): Promise<IResponseApplicationsNumber> => 
    apiGet<IResponseApplicationsNumber>(`${route}/getApplicationsNumber`, {params: {applicationStatusesID, search}})

/** Получение - Гражданство */
export const getCitizenships = (): Promise<IResponseCitizenships> => 
    apiGet<IResponseCitizenships>(`${route}/getCitizenships`)

/** Получение - Уровень образования */
export const getEducationLevels = (): Promise<IResponseEducationLevels> => 
    apiGet<IResponseEducationLevels>(`${route}/getEducationLevels`)

/** Получение - Статусы договоров */
export const getContractsStatuses = (): Promise<IResponseContractsStatuses> => 
    apiGet<IResponseContractsStatuses>(`${route}/getContractsStatuses`)

/** Получение - Тип договора */
export const getContractTypes = (): Promise<IResponseContractTypes> => 
    apiGet<IResponseContractTypes>(`${route}/getContractTypes`)

/** Получение - Вид договора */
export const getContractViews = (): Promise<IResponseContractViews> => 
    apiGet<IResponseContractViews>(`${route}/getContractViews`)

/** Получение - Тип программы */
export const getDocumentTypes = (): Promise<IResponseDocumentTypes> => 
    apiGet<IResponseDocumentTypes>(`${route}/getDocumentTypes`)

/** Получение - Документы по договору */
export const getContractDocuments = (): Promise<IResponseContractDocuments> => 
    apiGet<IResponseContractDocuments>(`${route}/getContractDocuments`)

/** Получение - Секции файлов по договору */
export const getContractSections = (): Promise<IResponseContractSections> => 
    apiGet<IResponseContractSections>(`${route}/getContractSections`)

/** Получение - Наименования отправок по договору */
export const getContractSended = (): Promise<IResponseContractSended> => 
    apiGet<IResponseContractSended>(`${route}/getContractSended`)

/** Получение - Статус печати */
export const getPrintStatus = (): Promise<IResponsePrintStatus> => 
    apiGet<IResponsePrintStatus>(`${route}/getPrintStatus`)

/** Получение - Статус коммерческого предложения */
export const getCommercialOffersStatuses = (): Promise<IResponseCommercialOffersStatus> => 
    apiGet<IResponseCommercialOffersStatus>(`${route}/getCommercialOffersStatuses`)

/** Получение - Документы для формирования по коммерческим предложениям */
export const getCommercialOffersDocuments = (): Promise<IResponseCommercialOffersDocuments> => 
    apiGet<IResponseCommercialOffersDocuments>(`${route}/getCommercialOffersDocuments`)

/** Получение - Должность операторов */
export const getAccessLevels = (): Promise<IResponseAccessLevels> => 
    apiGet<IResponseAccessLevels>(`${route}/getAccessLevels`)



/** Получение - Доступные сайты */
export const getAccessSites = (): Promise<IResponseAccessSites> => 
    apiGet<IResponseAccessSites>(`${route}/getAccessSites`)

/** Получение - Доступные разделы */
export const getAccessSections = (): Promise<IResponseAccessSections> => 
    apiGet<IResponseAccessSections>(`${route}/getAccessSections`)

/** Получение - Договора на подпись */
export const getContractSignatureStatuses = (): Promise<IResponseContractSignatureStatuses> => 
    apiGet<IResponseContractSignatureStatuses>(`${route}/getContractSignatureStatuses`)